export const allowedUnidentifiedDutyStatusChoices = [
  {
    name: "Driving",
    id: "D",
  },
  {
    name: "PC",
    id: "PC",
  },
  {
    name: "YM",
    id: "YM",
  },
];
